import React from 'react';
import {ScrollView, Text} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import Button from '/component/base/Button';
import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';
import KeyboardAvoidingView from '/component/layout/KeyboardAvoidingView';
import VisitWebsitePopover from '/component/partial/VisitWebsitePopover';
import {createPopoverProvider} from '/provider/PopoverProvider';

const StoryPopoverProvider = createPopoverProvider({isStorybook: true});

storiesOf('NO_SNAPSHOT/partial', module).add('VisitWebsitePopover', () => (
  // @ts-expect-error TS(2322): Type '{ children: Element; isStorybook: boolean; }... Remove this comment to see the full error message
  <KeyboardAvoidingView isStorybook={true}>
    <StoryPopoverProvider.Provider>
      <StoryPopoverProvider.Consumer>
        {({popoverShow}) => (
          <ScrollView>
            <Spacing size={20}>
              <FlexView>
                <Heading level={1}>Visit Website Popover</Heading>
                <Spacer size={16} />
                <Text>
                  The <Code>VisitWebsitePopover</Code> component is used
                  whenever user tries to open a link from the app in a browser.
                </Text>
                <Spacer size={16} />
                <Button onPress={() => popoverShow(VisitWebsitePopover)}>
                  Open link
                </Button>
                <Spacer size={16} />
                <Text>
                  The component uses the <Code>Popover</Code> component. Please,
                  see the <Code>Popover</Code> article in{' '}
                  <Code>NO_SNAPSHOT/base</Code> section in Storybook for more
                  information on that piece.
                </Text>
                <Spacer size={16} />
                <Text>
                  To handle 'Leave App' button pass <Code>onSubmit</Code> prop.
                </Text>
                <Spacer size={16} />
              </FlexView>
            </Spacing>
          </ScrollView>
        )}
      </StoryPopoverProvider.Consumer>
    </StoryPopoverProvider.Provider>
  </KeyboardAvoidingView>
));
